import { offerSelector } from './offer';
import { IState } from '../../../store';

export const selectIsByHomeowner = (state: IState): boolean => {
  const offer = offerSelector(state);

  return !!offer.isByHomeowner;
};
